import { BaseFormatter } from "./BaseFormatter";
import { IFormatter } from "./IFormatter";
import { Log } from "./Log";

export class FormatterShort extends BaseFormatter implements IFormatter 
{
    format(log: Log): { pre: string[], messages: string[], post: string[] }
    {
        let ans: string[] = [];
        ans.push(this.formatDateTime(log.date) + ": " + this.getMesssages(log.messages).filter(m => m).join(" - "));
        return { pre: [], messages: ans, post: [] };
    }
}